import { LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('requestform')
export class RequestForm {
    @PrimaryGeneratedColumn('increment',{
        name:'request_id'
    })
    requestId: number;

    // @Column('varchar',{
    //     name:'visitor_code',
    //     length:15
    // })
    // visitorCode: string;

    @Column('varchar',{
        name:'visit_type',
        length:15
    })
    visitType: string;

    @Column('varchar',{
        name:'employee_name',
        length:36
    })
    employeeName: string;

    @Column('int',{
        name:'employee_code'
    })
    employeeCode: number;

    @Column('varchar',{
        name:'department'
    })
    department: string;

    @Column('varchar',{
        name:'visitor_name',
        length:36
    })
    visitorName: string;

    @Column('varchar', {
        name:'visitor_card'
    })
    visitorCard: string;

    @Column('varchar',{
        name:'visitor_email'
    })
    visitorEmail: string;

    @Column('varchar',{
        name:'visitor_mobilenumber',
        length: 15
    })
    visitorMobileNumber: string;

    @Column('varchar', {
        name:'aadhar_number',
        length:'15'
    })
    aadharNumber: string;

    @Column('varchar',{
        name:'visitor_address'
    })
    visitorAddress: string;

    @Column('datetime',{
        name:'visitor_arrivaldate'
    })
    visitorArrivalDate: Date;

    @Column('datetime',{
        name:'visitor_departuredate'
    })
    visitorDepartureDate: Date;

    @Column('varchar',{
        name:'purpose_of_visit'
    })
    purposeOfVisit: string;

    @Column('varchar',{
        name:"whom_meet",
        length:36
    })
    whomMeet: string;

    @Column('varchar', {
        name:'transportation',
        length:'36'
    })
    transportation: string;

    @Column('varchar',{
        name:'vehicle_number',
        length:'36'
    })
    vehicleNumber: string;

    @Column('varchar', {
        name:'driver_name',
        length:36
    })
    driverName: string;

    @Column('varchar',{
        name:'status_by_hod',
        length:10
    })
    statusByHod: LeaveApprovalStatusEnum;

    @Column('varchar',{
        name:'status_by_hr',
        length:10
    })
    statusByHr:LeaveApprovalStatusEnum;

    @Column('varchar', {
        name:'rejection_reason',
        length: 255
    })
    rejectionReason: string;

    @Column('varchar',{
        name:'vaccination',
        length:15
    })
    vaccination: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
    
}
